// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1997":"2b417340","2140":"6156e622","4378":"d0e7d303","6438":"ea1a33ae"}[chunkId] + ".chunk.css";
};